<!-- =============================================================
     User Profile Dialog — V2 redesign
     panelClass 'wg-user-profile-dialog' on the CDK overlay pane
     ============================================================= -->

<div class="up-wrapper user-profile-popup wg-profile-redesign">

  <!-- ===== HEADER BANNER: avatar + name + role + username ===== -->
  <div class="profile-header-banner">
    <div class="profile-header-content">
      <div class="profile-avatar">
        <div class="avatar-circle" (click)="avatarInput.click()">
          <img *ngIf="avatarPreviewUrl" [src]="avatarPreviewUrl" class="avatar-image" alt="Avatar" />
          <span *ngIf="!avatarPreviewUrl">{{initials}}</span>
        </div>
        <div class="avatar-edit-icon" (click)="avatarInput.click()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>
          </svg>
        </div>
        <input #avatarInput type="file" accept="image/*" hidden (change)="onAvatarSelected($event)" />
      </div>
      <div class="profile-header-info">
        <h2 class="profile-full-name">{{userModel.Name}} {{userModel.Surname}}</h2>
        <span class="profile-username">&#64;{{userModel.UserName}}</span>
      </div>
    </div>
    <div class="profile-close" (click)="closeProfilePage()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </div>
  </div>

  <!-- ===== BODY: two-column layout ===== -->
  <div class="profile-body">

    <!-- LEFT COLUMN: Personal Details -->
    <div class="profile-col profile-col-left">
      <h3 class="profile-section-title">
        {{translationsService.translate('WebGalis_BasicInformation') || 'Personal Details'}}
      </h3>

      <!-- First Name + Last Name side by side -->
      <div class="profile-field-row profile-field-row-2col">
        <div class="profile-field">
          <label class="profile-label">{{translationsService.translate('WebGalis_Name')}}</label>
          <div class="profile-input-wrap">
            <sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false"
              [isPasswordInput]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
              [readOnlyCondition]="''" [(ngModel)]="userModel.Name" name="name"></sem-text-box>
          </div>
        </div>
        <div class="profile-field">
          <label class="profile-label">{{translationsService.translate('WebGalis_Surname')}}</label>
          <div class="profile-input-wrap">
            <sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false"
              [isPasswordInput]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
              [readOnlyCondition]="''" [(ngModel)]="userModel.Surname" name="surname"></sem-text-box>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="profile-field-row">
        <div class="profile-field">
          <label class="profile-label">{{translationsService.translate('WebGalis_Email')}}</label>
          <div class="profile-input-wrap profile-input-with-icon">
            <svg class="profile-field-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22,7 12,13 2,7"/>
            </svg>
            <sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false"
              [isPasswordInput]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
              [readOnlyCondition]="''" [(ngModel)]="userModel.Email" name="email"></sem-text-box>
          </div>
        </div>
      </div>

      <!-- Phone -->
      <div class="profile-field-row">
        <div class="profile-field">
          <label class="profile-label">{{translationsService.translate('WebGalis_MobileNumber')}}</label>
          <div class="profile-input-wrap profile-input-with-icon">
            <svg class="profile-field-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false"
              [isPasswordInput]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
              [readOnlyCondition]="''" [(ngModel)]="userModel.MobileNumber" name="mobilenumber"></sem-text-box>
          </div>
        </div>
      </div>

      <!-- Username (readonly) -->
      <div class="profile-field-row">
        <div class="profile-field">
          <label class="profile-label">{{translationsService.translate('WebGalis_Username')}}</label>
          <div class="profile-input-wrap">
            <sem-text-box [parentBindingProp]="''" [predefinedValueEvent]="''" [showTooltipValue]="false"
              [isPasswordInput]="false" [isNumberInput]="false" [isReadOnly]="true" [form]="f"
              [readOnlyCondition]="''" [(ngModel)]="userModel.UserName" name="username"></sem-text-box>
          </div>
        </div>
      </div>

      <!-- Task notification checkbox -->
      <div class="profile-field-row">
        <div class="profile-field profile-field-checkbox">
          <sem-check-box [form]="f" [showLabel]="false" [isReadOnly]="false"
            [(ngModel)]="userModel.TaskSubscriptionEnabled" name="taskSubscriptionEnabled"></sem-check-box>
          <label class="profile-label-inline">{{translationsService.translate('WebGalis_TaskNotification')}}</label>
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN: Access & Security -->
    <div class="profile-col profile-col-right">
      <h3 class="profile-section-title">
        {{translationsService.translate('WebGalis_AccessAndSecurity') || 'Dostop in varnost'}}
      </h3>

      <!-- Security Groups as chips -->
      <div class="profile-subsection">
        <label class="profile-subsection-label">{{translationsService.translate('WebGalis_UserUserGroups') || 'SECURITY GROUPS'}}</label>
        <div class="profile-group-chips">
          <span class="profile-chip" *ngFor="let group of userGroups; let i = index"
                [class.profile-chip-primary]="i === 0">
            {{group}}
          </span>
          <span class="profile-chip profile-chip-empty" *ngIf="!userGroups || userGroups.length === 0">
            No groups assigned
          </span>
        </div>
      </div>

      <!-- Authentication section -->
      <div class="profile-subsection profile-subsection-auth">
        <label class="profile-subsection-label">{{translationsService.translate('WebGalis_Authentication') || 'Avtentikacija'}}</label>
        <button class="profile-auth-btn" (click)="showPasswordChange = !showPasswordChange">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          {{translationsService.translate('WebGalis_ChangePassword') || 'Reset Password'}}
        </button>

        <!-- Password change fields (expandable) -->
        <div class="profile-password-section" *ngIf="showPasswordChange">
          <div class="profile-field">
            <label class="profile-label">{{translationsService.translate('WebGalis_CurrentPassword')}}</label>
            <div class="profile-input-wrap">
              <sem-text-box isPasswordInput="true" [parentBindingProp]="''" [predefinedValueEvent]="''"
                [showTooltipValue]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
                [readOnlyCondition]="''" [(ngModel)]="userModel.OldPassword" name="password"></sem-text-box>
            </div>
          </div>
          <div class="profile-field">
            <label class="profile-label">{{translationsService.translate('WebGalis_NewPassword')}}</label>
            <div class="profile-input-wrap">
              <sem-text-box isPasswordInput="true" [parentBindingProp]="''" [predefinedValueEvent]="''"
                [showTooltipValue]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
                [readOnlyCondition]="''" [(ngModel)]="userModel.NewPassword" name="newPassword"></sem-text-box>
            </div>
          </div>
          <div class="profile-field">
            <label class="profile-label">{{translationsService.translate('WebGalis_NewPasswordRepeat')}}</label>
            <div class="profile-input-wrap">
              <sem-text-box isPasswordInput="true" [parentBindingProp]="''" [predefinedValueEvent]="''"
                [showTooltipValue]="false" [isNumberInput]="false" [isReadOnly]="false" [form]="f"
                [readOnlyCondition]="''" [(ngModel)]="userModel.NewPasswordRepeat" name="newPasswordRepeat"></sem-text-box>
            </div>
          </div>
          <button class="profile-password-submit" (click)="changePass()">
            {{translationsService.translate('WebGalis_ChangePassword')}}
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- ===== FOOTER ===== -->
  <div class="profile-footer">
    <div class="profile-footer-left">
      <button class="profile-logout-btn" (click)="logout()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
        {{translationsService.translate('WebGalis_MenuTop_UserMenu_LogOut')}}
      </button>
    </div>
    <div class="profile-footer-right">
      <p class="p-status-message" *ngIf="statusMessage">{{statusMessage}}</p>
      <button class="profile-cancel-btn" (click)="closeProfilePage()">{{translationsService.translate('Cancel')}}</button>
      <button class="profile-save-btn" (click)="changeInfo()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
        </svg>
        {{translationsService.translate('WebGalis_SaveChanges') || 'Save Changes'}}
      </button>
    </div>
  </div>

</div>
